export default __webpack_public_path__ + "static/media/ergo.4ff402fe.PNG";